import { useLogout } from "@/api/console/login/useLogout";
import toast from "@/lib/toast";
import { SignOutRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Logout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trigger } = useLogout({
    onSuccess: (data) => {
      toast.success(data.message);
      navigate("/console/login", { replace: true });
    },
  });

  return (
    <div
      className="shadow-x flex cursor-pointer items-center justify-center border-l-2 py-4 pl-5 pr-4"
      onClick={() => {
        toast.loading(t("logout-loading"));
        trigger();
      }}
    >
      <SignOutRegular fontSize={20} />
    </div>
  );
}

export default Logout;
